import { NavNotificationBadge } from "@/features/onboarding/hooks/usePatientNotificationCounts";
import { useWorklistCounts } from "@/features/worklist/hooks/useWorklistCounts";

const WorklistNotificationCount = () => {
    const { badgeCount } = useWorklistCounts();

    return <NavNotificationBadge count={badgeCount} />;
};

export default WorklistNotificationCount;
